// extracted by mini-css-extract-plugin
module.exports = {"chip":"xaoysZcyofkmaPHQ3Bto","chipFix":"JLyzGyhg4FdbFiD79HEj","subIcon":"zzWph7iOO0UG88feqRvz"};